var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('span', { staticClass: "order-action" }, _vm._l(_vm.sortBtn, function (item) {
    return _c('el-button', _vm._b({ key: item.id, on: { "click": function click($event) {
          return _vm.handleChangeSort(item);
        } } }, 'el-button', item.config, false), [_vm._v(_vm._s(item.text))]);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };